var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { MealName, ProbioticName, TreatName, probioticInfo, recipeInfo, treatInfo, } from '@marketing/content';
var CHEWY_BUY_NOW_CTA = {
    label: 'Buy at Chewy',
    url: 'https://redir.pricespider.com/redirect?cid=66c7787e21e16619000c0cf0&url=https%3A%2F%2Fwww.chewy.com%2Fbrands%2Fnom-nom-136126&landingPageId=501',
};
var mealsBreadcrumb = {
    url: '/meals',
    label: 'All Meals',
    theme: 'dark',
};
var samplerBreadcrumb = {
    url: '/meals',
    label: 'All Recipes',
    theme: 'dark',
};
var treatsBreadcrumb = {
    url: '/other-products/treats',
    label: 'All Treats',
    theme: 'dark',
};
var probioticsBreadcrumb = {
    url: '/other-products/probiotics',
    label: 'All Probiotics',
    theme: 'dark',
};
var getStartedButton = {
    label: 'Get Started',
    url: '/profile',
};
var startMealPlanButton = {
    label: 'Start Meal Plan',
    url: '/account/plan',
};
var updateMealPlanButton = {
    label: 'Update Meal Plan',
    url: '/account/plan',
};
var mealItemButtons = {
    subscriber: updateMealPlanButton,
    unsubscribed: startMealPlanButton,
    default: getStartedButton,
};
var getExtraItemButton = function (productID) {
    return {
        subscriber: {
            label: 'Add To Order',
            url: "/account/extras/#".concat(productID),
        },
        unsubscribed: startMealPlanButton,
        default: {
            label: 'Add To Cart',
            url: "/profile/#".concat(productID),
        },
    };
};
export var pdpHeroSectionContent = (_a = {},
    _a[MealName.Chicken] = {
        headline: recipeInfo[MealName.Chicken].displayName,
        subhead: 'Even picky pups find it hard to resist our juicy chunks of chicken. It’s a meal that’ll keep them happy, healthy and doing the excited-for-dinner dance.',
        imageData: recipeInfo[MealName.Chicken].pdpImages,
        price: "".concat(recipeInfo[MealName.Chicken].priceLevel, "/4"),
        isForSubscribersOnly: false,
        breadcrumb: mealsBreadcrumb,
        buttons: mealItemButtons,
    },
    _a[MealName.Turkey] = {
        headline: recipeInfo[MealName.Turkey].displayName,
        subhead: 'Made with highly digestible turkey to support pups with sensitive tummies, it’s a floor-licking delicious addition to a grain-inclusive diet.',
        imageData: recipeInfo[MealName.Turkey].pdpImages,
        price: "".concat(recipeInfo[MealName.Turkey].priceLevel, "/4"),
        isForSubscribersOnly: false,
        breadcrumb: mealsBreadcrumb,
        buttons: mealItemButtons,
    },
    _a[MealName.Pork] = {
        headline: recipeInfo[MealName.Pork].displayName,
        subhead: 'Great for dog parents looking for an alternative to chicken or beef, it’s a meal you can confidently serve — and your pup will excitedly eat.',
        imageData: recipeInfo[MealName.Pork].pdpImages,
        price: "".concat(recipeInfo[MealName.Pork].priceLevel, "/4"),
        isForSubscribersOnly: false,
        breadcrumb: mealsBreadcrumb,
        buttons: mealItemButtons,
    },
    _a[MealName.Lamb] = {
        headline: recipeInfo[MealName.Lamb].displayName,
        subhead: 'This recipe provides a tasty protein alternative to chicken and beef, and is equally great for pup parents looking to serve a grain-inclusive diet.',
        imageData: recipeInfo[MealName.Lamb].pdpImages,
        price: "".concat(recipeInfo[MealName.Lamb].priceLevel, "/4"),
        isForSubscribersOnly: false,
        breadcrumb: mealsBreadcrumb,
        buttons: mealItemButtons,
    },
    _a[MealName.Beef] = {
        headline: recipeInfo[MealName.Beef].displayName,
        subhead: 'Pups go crazy for our savory chunks of protein-rich beef. This recipe supports your dog’s well-being and functional health.',
        imageData: recipeInfo[MealName.Beef].pdpImages,
        price: "".concat(recipeInfo[MealName.Beef].priceLevel, "/4"),
        isForSubscribersOnly: false,
        breadcrumb: __assign(__assign({}, mealsBreadcrumb), { theme: 'light' }),
        buttons: mealItemButtons,
    },
    _a[MealName.TurkeyChicken] = {
        headline: recipeInfo[MealName.TurkeyChicken].displayName,
        subhead: 'Featuring a duo of lean proteins, this recipe is an enriching and delicious choice for dogs craving variety.',
        imageData: recipeInfo[MealName.TurkeyChicken].pdpImages,
        price: "".concat(recipeInfo[MealName.TurkeyChicken].priceLevel, "/4"),
        isForSubscribersOnly: false,
        breadcrumb: mealsBreadcrumb,
        buttons: mealItemButtons,
    },
    _a[MealName.SamplerPack] = {
        headline: recipeInfo[MealName.SamplerPack].displayName,
        subhead: 'Try a variety of dog food recipes for a tasty price. It’s an easy, subscription-free way to find your pup’s favorite and add delight to their day.',
        imageData: recipeInfo[MealName.SamplerPack].pdpImages,
        price: "".concat(recipeInfo[MealName.SamplerPack].price),
        isForSubscribersOnly: false,
        breadcrumb: samplerBreadcrumb,
        buttons: {
            subscriber: {
                label: 'Add To Order',
                url: '/account/extras/#variety-pack-dogs-200g',
            },
            unsubscribed: startMealPlanButton,
            default: {
                label: 'Checkout Now',
                url: '/profile/otto',
            },
        },
    },
    _a[TreatName.ChickenJerky] = {
        headline: treatInfo[TreatName.ChickenJerky].displayName,
        subhead: 'Made with lean chicken and nothing else, it’s a naturally delicious, filler-free alternative to artificially flavored biscuits and chews.',
        imageData: treatInfo[TreatName.ChickenJerky].pdpImages,
        price: treatInfo[TreatName.ChickenJerky].price,
        isForSubscribersOnly: false,
        breadcrumb: treatsBreadcrumb,
        buyNowCTA: CHEWY_BUY_NOW_CTA,
        buttons: getExtraItemButton(TreatName.ChickenJerky),
    },
    _a[TreatName.BeefJerky] = {
        headline: treatInfo[TreatName.BeefJerky].displayName,
        subhead: 'Made with 100% protein-packed beef, it’s an irresistibly chewy snack that you and your pup can both feel good about.',
        imageData: treatInfo[TreatName.BeefJerky].pdpImages,
        price: treatInfo[TreatName.BeefJerky].price,
        isForSubscribersOnly: false,
        breadcrumb: treatsBreadcrumb,
        buyNowCTA: CHEWY_BUY_NOW_CTA,
        buttons: getExtraItemButton(TreatName.BeefJerky),
    },
    _a[TreatName.BeefBlueberry] = {
        headline: treatInfo[TreatName.BeefBlueberry].displayName,
        subhead: 'Featuring tender beef and nutritious blueberries, your pup will sit, stay and roll over for this snappy snack.',
        imageData: treatInfo[TreatName.BeefBlueberry].pdpImages,
        price: treatInfo[TreatName.BeefBlueberry].price,
        isForSubscribersOnly: false,
        breadcrumb: __assign(__assign({}, treatsBreadcrumb), { theme: 'light' }),
        buyNowCTA: CHEWY_BUY_NOW_CTA,
        buttons: getExtraItemButton(TreatName.BeefBlueberry),
    },
    _a[TreatName.ChickenCranberry] = {
        headline: treatInfo[TreatName.ChickenCranberry].displayName,
        subhead: 'Featuring lean chicken and healthy cranberries, these wholesome rounds strike the perfect balance of savory and sweet.',
        imageData: treatInfo[TreatName.ChickenCranberry].pdpImages,
        price: treatInfo[TreatName.ChickenCranberry].price,
        isForSubscribersOnly: false,
        breadcrumb: __assign(__assign({}, treatsBreadcrumb), { theme: 'light' }),
        buyNowCTA: CHEWY_BUY_NOW_CTA,
        buttons: getExtraItemButton(TreatName.ChickenCranberry),
    },
    _a[TreatName.SweetPotato] = {
        headline: treatInfo[TreatName.SweetPotato].displayName,
        subhead: 'Made from a single wholesome ingredient, it’s a chewy and low-fat treat that’s as sweet as your pup.',
        imageData: treatInfo[TreatName.SweetPotato].pdpImages,
        price: treatInfo[TreatName.SweetPotato].price,
        isForSubscribersOnly: false,
        breadcrumb: __assign(__assign({}, treatsBreadcrumb), { theme: 'light' }),
        buyNowCTA: CHEWY_BUY_NOW_CTA,
        buttons: getExtraItemButton(TreatName.SweetPotato),
    },
    _a[ProbioticName.FullSpectrum] = {
        headline: probioticInfo[ProbioticName.FullSpectrum].displayName,
        subhead: 'The health of your dog’s gut and microbiome has a huge say in overall wellness. That’s why our probiotics were vet-developed to help support digestion, nutrient absorption and immune system function in dogs.',
        imageData: probioticInfo[ProbioticName.FullSpectrum].pdpImages,
        price: probioticInfo[ProbioticName.FullSpectrum].price,
        isForSubscribersOnly: false,
        breadcrumb: probioticsBreadcrumb,
        buyNowCTA: CHEWY_BUY_NOW_CTA,
        buttons: getExtraItemButton(ProbioticName.FullSpectrum),
    },
    _a[ProbioticName.GITargeted] = {
        headline: probioticInfo[ProbioticName.GITargeted].displayName,
        subhead: 'Gut health can be one of the most effective pathways to overall health, which is why our GI-Targeted probiotics were vet-developed to support balanced digestion in dogs.',
        imageData: probioticInfo[ProbioticName.GITargeted].pdpImages,
        price: probioticInfo[ProbioticName.GITargeted].price,
        isForSubscribersOnly: false,
        breadcrumb: probioticsBreadcrumb,
        buyNowCTA: CHEWY_BUY_NOW_CTA,
        buttons: getExtraItemButton(ProbioticName.GITargeted),
    },
    _a);
